import React, { useState } from 'react';

const CartElement = (props) => {
  const arr = props.data;
  const arrEntries = Object.entries(arr);
  const keyValue = {};
  arrEntries.forEach(el => {
    const key = el[0];
    const value = el[1];
    keyValue[key] = value;
  });

  const [product, setProduct] = useState(keyValue);

  const handleQuantityChange = (event) => {
    event.preventDefault();
    let name = event.target.name;
    let value = event.target.value;

    if ((parseInt(value) > 0) && (parseInt(value) <= 99999)) {
        // Create a new product object based on the current state and the new quantity
        const updatedProduct = {
            ...product,
            [name]: value // Update the quantity
        };

        // Update the local state
        setProduct(updatedProduct);
        
        // Call the update function with the updated product
        props.updateCartItem(updatedProduct);
    }
};

  return (
    <React.Fragment>
      <tr className="display-none-mobile">
        <td>
          <div className="row image-title">
            <div className="col-md-3 cart-image">
              {props.data.book_cover !== null ? (
                <img alt="" src={`data:image/jpeg;base64,${props.data.book_cover}`} className="book-cover-image" />
              ) : (
                <img className="book-cover-image" src="ElsevierStyleSheet/images/ElsevierImage.png" alt="" />
              )}
            </div>
            <div className="col-md-9 book-title">
              <p className="font-14">{props.data.title}</p>
              <p className="font-14 margin-0"><strong>ISBN: </strong>{props.data.product_id}</p>
            </div>
          </div>
        </td>
        <td className="font-24">₹&nbsp;{props.data.total_price}</td>
        <td className="cart-discount">{props.data.discount_percentage}%&nbsp;off</td>
        <td className="font-16">
          <form className="counter-form" id={'form-' + props.data.cart_id}>
            <input
              type="number"
              min="1"
              max="99999"
              name="quantity"
              value={product.quantity}
              onChange={handleQuantityChange}
              className="qtyTextbox"
            />
          </form>
        </td>
        <td className="font-24">₹&nbsp;{props.data.subtotal}</td>
        <td>
          <button type="button"
            className="es-link colored flex-row pointer"
            onClick={(event) => {
              event.preventDefault();
              props.deleteCartItem(props.data.cart_id, props.data.product_id);
            }}
          >
            <svg viewBox="0 0 70 128" height="24" width="14">
              <path fill="#007398" d="M68.94 36.12L62 29 35 56 8 29l-7 7 27 27L1 90l7 7 27-27 27 27 7-7-27-27 26.94-26.88" />
            </svg>
            <span className="black-color-margin"> Remove</span>
          </button>
        </td>
      </tr>
    </React.Fragment>
  );
};

export default CartElement;